import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { InfluenzaCartComponent } from "./influenza-cart/influenza-cart.component";




@NgModule({
  declarations: [InfluenzaCartComponent],
  exports: [InfluenzaCartComponent],
  imports: [
    CommonModule
  ]
})
export class InfluenzaCartModule { }
